import React from 'react';
import styled from 'styled-components';

import bacground from '@/public/subscribe-layout-desk.png';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';

export const WhyBlockLayout = ({ children }) => {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  background: #f6f7f9;
  overflow: hidden;
  position: relative;
  ${backgroundImageMixin(bacground.src)}
`;

const Content = styled.div``;
